import React, {  useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

export default function Accreditation(props) {

    const [email, setEmail] = useState('')
    const [textReturn, setTextReturn] = useState('')        

    var accrediter =function(){
        console.log(email)
        fetch("https://playattitude.fr/add/accreditation",{
            method: "POST",
            headers:{'Content-Type': 'application/json',
            'Access-Control-Allow-Origin':'*'},
            body: JSON.stringify({email: email, date: new Date(), start: "00:00", end: "23:59", type: "aucun"})
        })
        .then(res => res.json())
        .then(res => {
            if(res.response)
                setTextReturn(res.response)
            else
                setTextReturn(res)
        })
    }

    return (
        <div  className="center">
            <h2>Accréditation</h2>
            <form noValidate autoComplete="off">
                <div >
                    <TextField id="standard-basic" label="Email" value={email} onChange={(event) => setEmail(event.target.value) }/>
                </div>
                <br/>
                <div>
                    <Button variant="contained" onClick={() => accrediter()}>Accréditer</Button>
                </div>
            </form>
            <div><p>{textReturn}</p></div>
        </div>
    );
}